// extracted by mini-css-extract-plugin
module.exports = {"switch":"welcomeLinks_switch__3aRx_","slider":"welcomeLinks_slider__2HtSC","round":"welcomeLinks_round__19Ruo"};